<ion-button (click)="goToHelp()">
    <ion-icon class="iconInfo" [ngClass]="color" name="information"></ion-icon>
</ion-button>
